export default function normalizePhone(phone: string): string | null {
    let matches = phone.match(/\((\d{3})\) (\d{3})-(\d{4})/);
    return matches
        ? matches.slice(1).join("")
        : null;
}


// WEBPACK FOOTER //
// ./ClientApp/utils/normalizePhone.ts